import main from './main';
import { NavItemType } from 'types';
import newOperation from './new-operation';
import newCommunication from './new-communication';
import history from './history';

const menuItems: { items: NavItemType[] } = {
    items: [main, newOperation, newCommunication, history]
};

// TODO - Apaño para mostrar un menú solo con el historial de operaciones

export const menuItemsOnlyReadUser: { items: NavItemType[] } = {
    items: [main, history]
};

export default menuItems;
